import { getGeoLocation } from './GetGeoLocationService';

export default { getGeoLocation };
